module.exports = __webpack_public_path__ + "media/fart-03.7c4af546.mp3";